import React from 'react';
import { motion } from 'framer-motion';
import { BrandEmblem } from './BrandEmblem';
interface PageHeaderProps {
  eyebrow: string;
  title: string;
  intro?: string;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function PageHeader({
  eyebrow,
  title,
  intro
}: PageHeaderProps) {
  return <section className="relative overflow-hidden bg-forest-700" data-id="element-350" data-mp="3mezlf40zjofy">
      <motion.div aria-hidden="true" initial={{
      opacity: 0,
      x: 40
    }} animate={{
      opacity: 0.12,
      x: 0
    }} transition={{
      duration: 0.3,
      ease: EASE,
      delay: 0.1
    }} className="pointer-events-none absolute -right-10 top-10 hidden md:block" data-id="element-351" data-mp="3mdg73iyw3ngt">
        <BrandEmblem primary="#F7F4ED" accent="#C6A15B" className="h-[420px] w-auto" title="" data-id="element-352" data-mp="38h2m3zv5d3xl" />
      </motion.div>
      <div className="relative mx-auto max-w-[1240px] px-5 pb-14 pt-32 sm:px-8 lg:px-12 lg:pb-20 lg:pt-40" data-id="element-353" data-mp="33myedee24rvg">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="flex items-center gap-3 text-[11px] uppercase tracking-wordmark text-gold-300" data-id="element-354" data-mp="2fx42p05h59cs">
          <span className="h-px w-8 bg-gold-400" aria-hidden="true" data-id="element-355" data-mp="2lz0gjjh7moh4" />
          {eyebrow}
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.05
      }} className="mt-5 max-w-3xl font-display text-4xl leading-[1.1] text-ivory-100 sm:text-5xl lg:text-[3.8rem]" data-id="element-356" data-mp="2qs1zc2kjf85z">
          {title}
        </motion.h1>
        {intro && <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.1
      }} className="mt-6 max-w-xl text-base leading-relaxed text-ivory-200/80" data-id="element-357" data-mp="28093m0e338uk">
            {intro}
          </motion.p>}
      </div>
    </section>;
}